<template lang="">
    <div class="section-cv">
          <div class="heading2-section cv">
            Achievements & Certifications
        </div>

           <!-- work -->
        <div class="work" v-for="achievement in achievements">
            <ItemGeneralInfo :place="achievement.name" :title="achievement.issuer" :end="achievement.receivedDate"/>
            <div class="section-context">
                {{achievement.url}}
            </div>
        </div>
        <!--  -->
    </div>
</template>
<script>
    import ItemGeneralInfo from './ItemGeneralInfo.vue';
export default {
    components:{
        ItemGeneralInfo
    },
    computed:{
         achievements(){
            var eds = this.$store.getters["cvbuilder/getCVInformation"]?.achievements || [];
            return eds;
        }
    }
}
</script>
<style scoped>
    .section-context{
        margin-right:1rem;
    }
</style>